import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { EventCountdownGrabber } from './components/EventCountdownGrabber';
import { EVENT_COUNTDOWN_SCHEMA_URL, EVENT_COUNTDOWN_COMPONENT_TYPE } from './EventCountdown.constants';

const EventCountdownAdd = loadable(() => import(/* webpackChunkName: "content/websiteEditorEventCountdownAdd" */ './components/EventCountdownAdd'), 'EventCountdownAdd');

const EventCountdownEdit = loadable(() => import(/* webpackChunkName: "content/websiteEditorEventCountdownEdit" */ './components/EventCountdownEdit'), 'EventCountdownEdit');

export const EventCountdownConfig: AdminJsonComponentConfig = {
  schemaUrl: EVENT_COUNTDOWN_SCHEMA_URL,
  componentType: EVENT_COUNTDOWN_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: EventCountdownAdd,
    dragComponentView: EventCountdownGrabber,
    editComponentView: EventCountdownEdit,
    createComponentView: EventCountdownEdit,
  },
} as const;
